var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"info-popup card"},[_c('Button',{staticClass:"close-btn",attrs:{"action":_vm.close}}),_vm._v(" "),_c('h1',{staticClass:"popup-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"scrolling-content wysiwyg-content",domProps:{"innerHTML":_vm._s(_vm.info_text)}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d06a2ab6","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-svg-inline-loader/dist/index.min.js??ref--6!./src/components/game/budget/BudgetInfoPopup.vue
// module id = null
// module chunks = 